import { instance, endpoint, isMock, generator } from 'api'
import { mocker } from 'api/hrms27u/mocker'

export default {
  getLabels () {
    if (isMock) return generator(mocker.labels())
    return instance().get(endpoint + '/hrms27u/labels')
  },
  getIndex (searchParams) {
    if (isMock) return generator(mocker.index())
    let sendParams = {}
    let stdate = ''
    let endate = ''
    if (typeof searchParams !== 'undefined') {
      stdate = (typeof searchParams.dtestrt.replace(/\//g, '') !== 'undefined' ? searchParams.dtestrt.replace(/\//g, '') : '')
      endate = (typeof searchParams.dteend.replace(/\//g, '') !== 'undefined' ? searchParams.dteend.replace(/\//g, '') : '')
      sendParams = {
        p_numreq: (typeof searchParams.numreq !== 'undefined' ? searchParams.numreq : ''),
        p_codpos: (typeof searchParams.codpos !== 'undefined' ? searchParams.codpos : '')
      }
    }
    return instance().get(endpoint + '/hrms27u/index/' + stdate + '/' + endate, { params: sendParams })
  },
  postSendApprove (sendParams) {
    if (isMock) return generator(mocker.sendApprove())
    return instance().post(endpoint + '/hrms27u/sendApprove', sendParams)
  }
}



// WEBPACK FOOTER //
// ./src/api/hrms27u/index.js